import { Typography } from '@material-ui/core'
import MultipleTags from 'components/inputs/MultipleTags'
import { Child, Item } from 'contexts/Flow/types'
import { useForm } from 'contexts/Form/formContext'
import React from 'react'
import useTranslator from 'utils/hooks/Translator'
import { getTranslationKeys } from 'utils/i18n/types'
import { GroupChildKeys } from './GroupChildKeys'

export function GroupChild({ items, title }: Child): JSX.Element | null {
  const { getTranslation } = useTranslator()
  const {
    state: { dataForm },
  } = useForm()

  const renderItems = (items: Item[], title?: string): JSX.Element | null => {
    const translatedTitle = getTranslation(title as getTranslationKeys)

    const validItems = items.filter((item) => {
      const ai123EntriesToHidden = item.sendUser

      if (
        dataForm?.metadata?.type === 'AI123' &&
        dataForm.blockMode &&
        dataForm.blockMode !== 'PASSIVE' &&
        ai123EntriesToHidden
      ) {
        return false
      }

      if (item.outputs && item.outputs.hidden) {
        return false
      }

      return true
    })

    if (validItems.length === 0) {
      return null
    }

    return (
      <React.Fragment>
        {validItems.map((item, index) => (
          <div key={index} style={{ marginBottom: '16px' }}>
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 600,
                color: 'rgba(0, 0, 0, 0.87)',
                marginBottom: '12px',
                fontSize: '16px',
              }}
            >
              {translatedTitle}
            </Typography>

            <GroupChildKeys {...item} />
          </div>
        ))}
      </React.Fragment>
    )
  }

  if (title === 'Tags') {
    return (
      <React.Fragment>
        <Typography
          variant="subtitle1"
          style={{
            fontWeight: 600,
            color: 'rgba(0, 0, 0, 0.87)',
            marginBottom: '12px',
            fontSize: '16px',
          }}
        >
          {title}
        </Typography>
        <MultipleTags hideTitle inColumns noPadding />
      </React.Fragment>
    )
  }

  return renderItems(items, title)
}
